export default "__VITE_ASSET__6c8fa0e6__"